<!-- 
日付選択カレンダー
@props
  dateSub : 文字で表示される日付の初期値
  defaultFocus : カレンダーのフォーカスの初期値。
  events : カレンダーに表示するイベント情報
  minDate : カレンダーで選択可能な最小日(未指定の場合下限なし)
-->

<template>
  <div>
      <v-menu v-model="showDatePicker" z-index="0" :close-on-click="false" :close-on-content-click="false">
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            color="#0ddbc7"
            v-model="localizedDate"
            v-bind="attrs"
            v-on="on"
            readonly
            outlined
            dense
            class="date-input text-h7"
            hide-details="auto"
          ></v-text-field>
        </template>
        <v-date-picker
          locale="jp"
          v-model="date"
          elevation="12"
          :width="400"
          :day-format="pickupDate"
          :min="dateRange.min"
          :max="dateRange.max"
          :events="eventsRef"
          :picker-date.sync="pickerDate"
          :active-picker.sync="activePicker"
          :allowed-dates="allowedDates"
        >
        <v-spacer></v-spacer>
          <v-btn text color="primary" @click="datePickerCancel">キャンセル</v-btn>
          <v-btn text color="primary" @click="datePickerApply">OK</v-btn>
        </v-date-picker>
      </v-menu>
  </div>
</template>

<script>
import DateWrapper from "../../logic/common/date-wrapper";

export default {
  computed: {
    /**
     * 検索対象日を表示日に変換して返す
     */
    localizedDate() {
      return new DateWrapper(this.registrationDate).format.localizedDate;
    },
  },
  props: ["dateSub", "events", "minDate", "maxDate", "defaultFocus", "recordType"],
  data() {
    this.workDate = ""; //初期値
    const now = new DateWrapper(Date.now()).format;
    // カレンダー用日付を設定する
    this.setDateForDatePicker(now);
    return {
      showDatePicker: false,
      date: this.defaultFocus ? this.defaultFocus : now.systemDate,
      beforeFocus: this.defaultFocus ? this.defaultFocus : now.systemDate,
      registrationDate: this.workDate,
      pickerDate: null,
      activePicker: null,
      dateRange: {
        min: this.minDate,
        max: this.maxDate ? this.maxDate : now.systemDate,
      },
      eventsRef: this.eventsFormat,
    };
  },
  watch: {
    /**
     * カレンダーの表示月が変更されたのであれば、月間イベントを再取得する
     */
    pickerDate(newval, oldval) {
      if (this.activePicker == "DATE") {   // 日付が表示されている画面の時のみ月間イベント再取得を行う
        const newDate = new DateWrapper(newval);
        const oldDate = new DateWrapper(oldval);
        let updated = false;
        if (newDate.isValid && oldDate.isValid) {
          if (newDate.format.systemDate != oldDate.format.systemDate) {
            updated = true;
          }
        } else if (newDate.isValid) {
          updated = true;
        }
        if (updated) {
          this.$emit("on-update-calendar-month", newDate);
        }
      }
    },
    /**
     * カレンダーの月間イベントを更新する
     */
    events() {
      this.eventsRef = null;
      this.eventsRef = this.eventsFormat;
    },
    dateSub(newDate) {
      let now = new DateWrapper(newDate).format;
      this.date = now.systemDate;
      this.registrationDate = now.systemDate;
    },
  },
  methods: {
    /**
     * 有効日を設定する
     */
    allowedDates(val) {
        // 水揚げ日選択カレンダーの場合はイベント情報をもとに有効日を設定する
        if (this.recordType == "UNLOADING") {
            return this.events.unloading.includes(val);
        }
        return val;
    },
    /**
     * 選択日を更新する
     */
    updateRegistrationDate(newRegistrationDate) {
      if (this.registrationDate != newRegistrationDate) {
        this.registrationDate = newRegistrationDate;
        this.beforeFocus = newRegistrationDate;
        this.date = newRegistrationDate;
        this.$emit("on-update-registration-date", this.registrationDate);
      }
    },
    /**
     * カレンダーピッカーの選択をキャンセルして閉じる
     */
    datePickerCancel() {
      // カレンダーピッカーのカーソルを変更前に戻す
      this.date = this.beforeFocus;
      // カレンダーピッカーを開いた時の表示月を変更前に戻す
      this.pickerDate = this.beforeFocus;
      // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
    /**
     * カレンダーピッカーの選択日を検索対象日に反映する
     */
    datePickerApply() {
      this.updateRegistrationDate(this.date);
      // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
    /**
     * 日時文字列をオフセット日だけずらして返却する
     */
    // parseDateInfo(dateString, offsetDays) {
    //   const currentDate = new DateWrapper(dateString).appendDay(offsetDays);
    //   const currentMonth = currentDate.format.build(
    //     (d) => `${d.date.y}-${d.date.m}`
    //   );
    //   return {
    //     month: currentMonth,
    //     date: currentDate.format.systemDate,
    //   };
    // },
    /**
     * 対象日から日を取得する
     */
    pickupDate(date_string) {
      return new DateWrapper(date_string).format.build((d) => `${d.date.d}`);
    },
    /**
     * カレンダー上にイベントを表示する
     */
    eventsFormat(dateString) {
      const date = new DateWrapper(dateString).format.systemDate;
      return [
        {
          // 作業記録
          target: this.events.worklog,
          color: "orange",
        },
        {
          // 出荷
          target: this.events.shipping,
          color: "green",
        },
        {
          // 水揚げ
          target: this.events.unloading,
          color: "red",
        },
        {
          // 使用海水
          target: this.events.seawater,
          color: "blue",
        },
      ].map((item) => {
        if (item.target && item.target.some((item) => item == date)) {
          return item.color;
        }
        // イベントがないものは背景色を透明にして表示する
        // 4つの点が並んだ時に、点の位置と色で分かるよう配慮するため
        return "no-background-color";
      });
    },
    /**
     * カレンダー用日付を設定する
     */
    setDateForDatePicker(now) {
      if (this.dateSub) {
        this.workDate = this.dateSub;
      } else {
        this.workDate = now.systemDate;
      }
    },
  },
};
</script>

<!--DatePickerのスタイルを継承して書き換え、2つ目で改行するようにする -->
<style>
.v-date-picker-table th {
  background-color: #ffffff !important;
}

.v-date-picker-table__events {
  max-width: 20px !important;
  left: 6px !important;
  top: 24px !important;
}

.v-date-picker-table--date div {
  float: left !important;
  margin-bottom: 1px !important;
  margin-left: 1px !important;
  margin-right: 0px !important;
  margin-top: 0px !important;
}

.no-background-color {
  background-color: transparent !important;
  border-color: transparent !important;
}
/* 高さ44pxに統一（必要に応じて値を変更） */
.date-input :deep(.v-input__slot) {
  min-height: 44px !important;
  height: 44px;
}
.date-input :deep(input),
.date-input :deep(.v-label),
.date-input :deep(.v-select__selections) {
  line-height: 44px;
  height: 44px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
